// 외부 래퍼(전용 브라우저)가 URL의 `?mode=out`을 감지해 프로그램을 종료한다.
// shallow 이동이라 화면 전환 없이 주소창 표시만 바뀐다.
const exit = (router) => {
  if (router.asPath !== "/?mode=out") {
    router.push(router.asPath, "/?mode=out", { shallow: true });
  }
};

export default exit;
